import {Dialog, Typography, Drawer} from '@mui/material';
import {styled} from '@mui/system';

export const StyledDialog = styled(Dialog)(({theme}) => ({
  '& .MuiPaper-root': {
    borderRadius: '12px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)',
    maxWidth: '400px'
  },
  '&.DeliveryFeeModel .MuiPaper-root': {
    width: '360px'
  },
  '&.AddToFavoriteModal .MuiPaper-root': {
    width: '480px',
    maxWidth: '480px'
  },
  '&.MakroFleetDeliveryModal .MuiPaper-root': {
    width: '480px',
    maxWidth: '480px'
  },
  '& .MuiDialogTitle-root': {
    padding: theme.spacing(2, 2, 2, 2)
  },
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2, 2, 4, 2)
  },
  '&.DeliveryFeeModel .MuiDialogContent-root': {
    padding: theme.spacing(1, 2, 4, 2)
  },
  '&.AddToFavoriteModal .MuiDialogContent-root': {
    padding: theme.spacing(1, 2, 4, 2)
  },
  '&.creditDetailsModal .MuiPaper-root': {
    width: '618px',
    maxWidth: '618px'
  },
  '&.creditDetailsModal .MuiDialogContent-root': {
    padding: theme.spacing(1, 2, 2, 2)
  }
}));

export const StyledSameDelivery = styled(Typography)(() => ({
  fontSize: '16px',
  fontWeight: '700',
  background: 'linear-gradient(to right, #F226A0, #FFAF37)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent'
}));

export const StyledBottomSheet = styled(Drawer)(() => ({
  '& .MuiPaper-root': {
    borderRadius: '16px 16px 0px 0px',
    boxShadow: '0px 4px 12px 0px rgba(0, 0, 0, 0.08)'
  }
}));

export const Footnote = styled(Typography)`
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
`;

export const BulletPoints = styled('ul')<{isReactNativeView?: boolean}>(({isReactNativeView, theme}) => ({
  margin: '0px',
  padding: isReactNativeView ? '0px' : theme.spacing(0, 2),
  li: {
    marginTop: theme.spacing(1)
  },
  'li:first-child': {
    marginTop: 0
  }
}));

export const DeliveryStyledPDPNextDay = styled(Typography)(({theme}) => ({
  fontSize: theme.spacing(2),
  // fontWeight: theme.typography.h3.fontWeight,
  lineHeight: theme.spacing(2.5),
  color: theme.palette.common.mds_global_color_red_25,
  '&.nextdaybulky': {
    paddingRight: theme.spacing(1)
  }
}));
